import styled from '@emotion/styled';

export const ControlRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;

    color: ${({ theme }) => theme.colors.secondary[700]};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;
